export default __webpack_public_path__ + "assets/marker.0a3e0986.png";